













import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'ProductDetailsPrice',
  props: {
    price: {
      type: Number,
      required: true,
    },
  },
  computed: {
    formatedPrice(): string {
      return `${this.price.toString()}`
    },
  },
})
